const GraphNetecs = require('graph-netecs/js/GraphNetecs').GraphNetecs;
const fanAbstract = require('./fanAbstract').fanAbstract;
const unit = require('./unit').unit;
const Ppm = require('./ppm').default;
const Constants = require('graph-netecs/js/Constants').Constants;

/**
 * Wykres zbiorczy
 */
class fanSummary extends fanAbstract {
    constructor(html, data, store) {
        super(html, data);
        this.store = store;
        this.graph = new GraphNetecs(unitsList);
        this.graph.multipleAxis = true;
        this.graph.graph.config = {y: {thickness: 50}};

        if(this.graph.html)
            this.graph.html.addEventListener('contextmenu', e => this.contextMenu(e));

        this.unitsInited = false;

        if (html) {
            this.html.append(this.graph.html);
            let axisName = `<span class="performance-axis-label" data-force-vue-translate="true" data-translate-code="performance">${this.translate("performance")}</span>`;
            let axisDescription = new DOMParser().parseFromString(axisName, 'text/html').body.firstChild;
            this.html.append(axisDescription);
        }
    }

    /**
     * wstępne przygotowanie do rysowania wykresów. Wykonuje się tylko raz na jedno wejście na stronę
     * @private
     */
    _drawInit() {
        if (this.store.state.selectedFan) {
            this._drawInited = true;
            this.createInitialLines();

            this.graph.addLine(this.fanRecalced.lines.DynamicPressure);

            for (let line of Object.values(this.fanRecalced.lines)) {
                line.line.ys = this.graph.getAxisByKind(line.kind);
                switch (line.kind) {
                    case 'pressure':
                        line.line.ys.config = {unit: unitsList.pressure.list[0]};
                        break;
                    case 'efficiency':
                        line.line.ys.config = {unit: unitsList.efficiency.list[0]};
                        break;
                    case 'power':
                        line.line.ys.config = {unit: unitsList.power.list[0]};
                        break;
                    case 'noise':
                        line.line.ys.config = {unit: unitsList.noise.list[0]};
                        break;
                    case 'current':
                        line.line.ys.config = {unit: unitsList.current.list[0]};
                        break;
                }
            }

            this.setVisibility();

            let axis = this.graph.graph.xs;
            unit.registerAxis('performance', axis, () => this.changed.call(this));//rejestrujemy oś: gdy zmienimy jednostkę wydajności to w tej osi też się zmieini
            axis.svg.oncontextmenu = e => {//prawy kalwisz myszy
                unit.menu(e, 'performance');
            };
            axis.svg.addEventListener('click', e => {
                if (e.target.findParent(x => x.classList.contains('axisBtn'))) {//gdy klikniemy na przycisk przy nazwie osi
                    unit.menu(e, 'performance');
                }
            });

            this.setGraphUnitsMenu(this.graph.getAxisByKind('pressure'), 'pressure', 'p');
            this.setGraphUnitsMenu(this.graph.getAxisByKind('efficiency'), 'efficiency', '&eta;');
            this.setGraphUnitsMenu(this.graph.getAxisByKind('power'), 'power', 'P');
            this.setGraphUnitsMenu(this.graph.getAxisByKind('noise'), 'noise', 'L<sub>A6</sub>');
            this.setGraphUnitsMenu(this.graph.getAxisByKind('current'), 'current', 'I');

            this.setAxisesPriority();

            this.graph.getAxisByKind('efficiency').config = {endLimit: 1}

            this.graph.graph.mouseClick(this.pressureClick.bind(this));

            this.fanRecalced.lines.TotalPressure.changedFrequency(() => {
                this.dragEventElementType = "frequency";
                this.data.workPointFrequency = this.fanRecalced.lines.TotalPressure.frequency;
                this.data.workPointRotationSpeed = this.data.workPointFrequency / Constants.frequency * this.data.engine_rpm;
                this.changed.call();
            });

            this.fanRecalced.lines.StaticPressure.changedFrequency(() => {
                this.dragEventElementType = "frequency";
                this.data.workPointFrequency = this.fanRecalced.lines.StaticPressure.frequency;
                this.data.workPointRotationSpeed = this.data.workPointFrequency / Constants.frequency * this.data.engine_rpm;
                this.changed.call();
            });

            // NVS-92
            this.fanRecalced.lines.TotalPressure.changedTemperature(() => {
                this.dragEventElementType = "temperature";
                this.data.workPointTemperature = this.fanRecalced.lines.TotalPressure.temperature;
                this.data.workPointAirDensity = this.fanRecalced.lines.TotalPressure.density;
                this.store.state.fourthStepParametersSelected.temperature.value = this.fanRecalced.lines.TotalPressure.temperature;
                this.store.state.fourthStepParameters.temperature.value = this.fanRecalced.lines.TotalPressure.temperature;
                this.changed.call();
            });
            // NVS-92
            this.fanRecalced.lines.StaticPressure.changedTemperature(() => {
                this.dragEventElementType = "temperature";
                this.data.workPointTemperature = this.fanRecalced.lines.StaticPressure.temperature;
                this.data.workPointAirDensity = this.fanRecalced.lines.StaticPressure.density;
                this.store.state.fourthStepParametersSelected.temperature.value = this.fanRecalced.lines.StaticPressure.temperature;
                this.store.state.fourthStepParameters.temperature.value = this.fanRecalced.lines.StaticPressure.temperature;
                this.changed.call();
            });
        }
    }

    _unitsInit(){
        for(let unitId in this.store.state.ValueUnitMap){
            let selectedUnit = this.store.state.ValueUnitMap[unitId];

            if(selectedUnit && selectedUnit.selected && selectedUnit.selected.unit){
                this.getUnitObject().selectUnitOfTypeName(unitId, selectedUnit.selected.unit.id);
            }
        }

        this.unitsInited = true;
    }

    translate(code, displayErrors = true) {
        let arg = {
            type: 'translate',
            code: code,
            displayErrors: displayErrors,
            out: ""
        }

        this.store.commit(arg);

        return arg.out;
    }

        /**
     * kliknięto na wykres: dostosowujemy punkt rządany
     * @param e event
     */
    pressureClick(e) {
        if (this.requestedPointEnabled) {
            let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));
            let max_number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.data && this.store.state.activeFun.data.number_of_fans) ?  this.store.state.activeFun.data.number_of_fans : (this.numberOfFans ? this.numberOfFans : 1));
            let denominator = 1;

            if(max_number_of_fans > _number_of_fans)
                denominator = max_number_of_fans;

            this.dragEventElementType = "requestedPoint";
            this.data.workPointPerformance = e.x * denominator;
            this.data.workPointPerformanceHour = e.x * 3600 * denominator;
            this.data.workPointPressure = e.getByAxis(this.graph.getAxisByKind('pressure'));
            this.changed.call();
        }
    }

    setAxisesPriority() {
        this.graph.getAxisByKind('pressure').config = {priority: 1};
        this.graph.getAxisByKind('power').config = {priority: 2};
        this.graph.getAxisByKind('efficiency').config = {priority: 3};
        this.graph.getAxisByKind('noise').config = {priority: 4};
        this.graph.getAxisByKind('current').config = {priority: 5};
    }

    /**
     * przygotowuje oś pod zmianę jednostki:
     * -ustawia jednostkę startową
     * -dodaje event prawego kalwisza myszy
     * -ustawia, że jak na innej osi zmienimy tę jednostkę, to w tej osi też się zmieni
     * @param axis
     * @param typeName
     * @param name
     */
    setGraphUnitsMenu(axis, typeName, name) {
        axis.config = {titleHTML: name};
        unit.registerAxis(typeName, axis, () => this.changed.call(this));
        axis.svg.oncontextmenu = e => {
            unit.menu(e, typeName, axis);
        };
        axis.svg.addEventListener('click', e => {
            if (e.target.findParent(x => x.classList.contains('axisBtn'))) unit.menu(e, typeName);
        });
    }

    getUnitObject() {
        return unit;
    }

    /**
     * funkcja wywołuje się przy każdej zmianie czegokolwiek
     * odswieża wykres
     */
    draw() {
        if (!this._drawInited)
            this._drawInit();

        this.data.calcArea();
        this.data.calcInletArea();
        this.validateData();

        this.graph.points.filter(p => p.type == 'workPoint' || p.type == 'maxPoint').forEach(p => this.graph.removePoint(p));

        if (this.canDraw) {
            this.refreshLines();
            this.setVisibility();
            this.graph.minX = this.fanRecalced.min;
            this.graph.maxX = this.fanRecalced.max;

            // this.graph.minXOrg = this.fan.min;
            // this.graph.maxXOrg = this.fan.max;

            this.graph.minXOrg = this.fanRecalced.min;
            this.graph.maxXOrg = this.fanRecalced.max;

            this.drawRequestedLine();
            // NVS-27
            this.drawInstalledPowerLine(this.graph, this.fanRecalced.lines.PowerOnShaftWithMaterial || this.fanRecalced.lines.PowerOnShaft, this.dragEventElementType);
            this._drawMaxEfficiency();

            if(!this.unitsInited)
                this._unitsInit();

            this.graph.draw();
        } else {
            this.graph.points.forEach(p => this.graph.removePoint(p));
        }
    }

    /**
     * pokazuje/ukrywa linie, w zależności od tego, co zaznaczyliśmy w checkboxach
     */
    setVisibility() {
        let voltages = this.getActiveFunVoltages();

        for (let filtId in this.store.state.partsOfTheGraph.mainAxisParams) {
            let filt = this.store.state.partsOfTheGraph.mainAxisParams[filtId];

            if (filt.specificParts) {
                for (let curentLineID in filt.specificParts) {
                    let curentLine = filt.specificParts[curentLineID];

                    if (curentLine.active) {
                        let shouldAdd = true;

                        if (curentLineID == "ElectricalPower") {
                            this.fanRecalced.lines[curentLineID].engine_efficiency_3_4 = this.store.state.activeFun.engine.efficiency_3_4;
                        }

                        if (curentLineID == "Amperage" || curentLineID == "AmperageV2") {
                            if (curentLineID == "Amperage" && voltages[0]) {
                                this.fanRecalced.lines[curentLineID].voltage = voltages[0];
                                this.fanRecalced.lines[curentLineID].engine_efficiency_3_4 = this.store.state.activeFun.engine.efficiency_3_4;
                                this.fanRecalced.lines[curentLineID].engine_power_factor = this.store.state.activeFun.engine.power_factor;
                            } else if (curentLineID == "AmperageV2" && voltages[1]) {
                                this.fanRecalced.lines[curentLineID].voltage = voltages[1];
                                this.fanRecalced.lines[curentLineID].engine_efficiency_3_4 = this.store.state.activeFun.engine.efficiency_3_4;
                                this.fanRecalced.lines[curentLineID].engine_power_factor = this.store.state.activeFun.engine.power_factor;
                            } else {
                                this.graph.removeLine(this.fanRecalced.lines[curentLineID]);
                                shouldAdd = false;
                            }
                        }

                        if (!this.graph.containsLine(this.fanRecalced.lines[curentLineID]) && shouldAdd == true && this.fanRecalced.lines[curentLineID]) {
                            this.graph.addLine(this.fanRecalced.lines[curentLineID]);
                        }
                    } else
                        this.graph.removeLine(this.fanRecalced.lines[curentLineID]);

                }
            }
        }
    }

    getActiveFunVoltages() {
        if (this.store.state.activeFun && this.store.state.activeFun.data && this.store.state.activeFun.data.network_frequency && this.store.state.activeFun.engine) {
            let frequency = this.getSelectedElementOfOption(this.store.state.fourthStepParametersSelected.network_frequency.options[0].elements);

            let voltage = this.store.state.activeFun.engine['voltage_' + frequency + '_hz'];

            if (voltage) {
                let voltages = voltage.split("/");

                return voltages;
            }
        }

        return [];
    }

    getSelectedElementOfOption(elements) {
        for (let elementId in elements) {
            if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                return elements[elementId].value;
        }

        return null;
    }

    /**
     * rysuje punkt maksymalnej sprawności (nominalny (optymalny))
     * @private
     */
    _drawMaxEfficiency() {
        let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));

        let totalEfficientyGraph = this.fanRecalced.lines.TotalEfficiency;
        let staticEfficiency = this.fanRecalced.lines.StaticEfficiency;

        totalEfficientyGraph.power.number_of_fans = 1;
        totalEfficientyGraph.pressure.number_of_fans = 1;
        totalEfficientyGraph.number_of_fans = 1;


        let maxTotal = totalEfficientyGraph.findMaximum(totalEfficientyGraph.min / _number_of_fans, totalEfficientyGraph.max / _number_of_fans);
        let maxStatic = staticEfficiency.findMaximum(staticEfficiency.min  / _number_of_fans, staticEfficiency.max / _number_of_fans);
        let maxActive = (this.data.workPointPressureType == 'static') ? maxStatic : maxTotal;

        maxActive.x = maxActive.x * _number_of_fans;

        totalEfficientyGraph.power.number_of_fans = _number_of_fans;
        totalEfficientyGraph.pressure.number_of_fans = _number_of_fans;
        totalEfficientyGraph.number_of_fans = _number_of_fans;

        for (let curentLine of Object.values(this.graph.lines)) {
            if (curentLine != this._requestedLine) {
                this._drawMaxEfficiencyPoint(this.graph, curentLine, maxActive.x);
            }
        }

    }

    /**
     * rysuje charakterystykę instalacji
     */
    drawRequestedLine() {
        let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));

        this.workPointResult = {};
        let requestedPressure = this.data.workPointPressure;
        let requestedPerformance = this.data.workPointPerformance;
        let isStatic = this.data.workPointPressureType === 'static';//total czy static

        if (!requestedPerformance || !requestedPressure) {
            this._clearRequestedLine();

            return;
        }

        this._generateRequestedLine(true);

        let pressurePolynomial;

        if (!this.graph.containsLine(this._requestedLine))
            this.graph.addLine(this._requestedLine);

        if (isStatic) {
            pressurePolynomial = this.fanRecalced.lines.StaticPressure.polynomial;
        } else {
            pressurePolynomial = this.fanRecalced.lines.TotalPressure.polynomial;
        }
        //wyznaczamy punkt przecięcia ciśnienia i charakterystyki instalacji
        //więc szukamy takeigo X, dla którego ciśnienie(x) = charakterystykaInstalacji(x)
        //więc przekształcamy to do równania charakterystykaInstalacji(x) - ciśnienie(x) = 0
        //więc wyznaczamy miejsca zerowe, ale tylko w zakresie w którym jest wentylator
        let zeroPoints = this._requestedLine.polynomial.subtract(pressurePolynomial).calcZeroPointsRange(this.fanRecalced.min / _number_of_fans, this.fanRecalced.max / _number_of_fans);
        if (zeroPoints.length > 0) {

            let x = zeroPoints[0];//miejsc zerowych może być teoretycznie kilka, więc zeroPoints to tablica, ale my bierzemy pierwsze z brzegu

            for (let curentLine of Object.values(this.graph.lines)) {
                if (curentLine != this._requestedLine) {
                    this._drawWorkpoint(x * _number_of_fans, this.graph, curentLine);
                }
            }
        }

        this._generateRequestedLine();
        this._generateRequestedPoint();
        this.requestedPoint.ys = this.fanRecalced.lines.TotalPressure.line.ys;

        if (this.graph.containsLine(this.fanRecalced.lines.TotalPressure) || this.graph.containsLine(this.fanRecalced.lines.StaticPressure) || this.graph.containsLine(this.fanRecalced.lines.DynamicPressure)) {//jeśli mamy jakieś cisnienie, czyli mamy oś ciśnienia
            this.graph.addPoint(this.requestedPoint);
        } else {
            this.graph.removePoint(this.requestedPoint);
        }
    }

    /**
     * Wywalamy punkt rządany i charakterystykę instalacji
     * @private
     */
    _clearRequestedLine() {
        this.graph.removeLine(this._requestedLine);
        delete this._requestedLine;

        this.graph.removePoint(this.requestedPoint);
        delete this.requestedPoint;
    }

    /**
     * menu pod rpawym przyciskiem myszy
     * @param e event
     * @returns {boolean}
     */
    contextMenu(e) {
        let elementObjectClicked = e.target.findParent(el => el.object);

        if (elementObjectClicked) {
            if (elementObjectClicked.object.contextMenu) {
                elementObjectClicked.object.contextMenu(e);
                return false;
            }
        }

        let ppmButtons = [];

        if(this.store.state.selectedSecondStepElement.multiple_fans != 1) {
            if (this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled) {
                ppmButtons.push({
                    'ico': '', 'text': this.translate('graph_block_frequency'), 'func': () => {
                        this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled = false;
                        this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = '';

                        this.fanRecalced.lines.StaticPressure.changingFerequencyEnabled = false;
                        this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = '';
                    }
                });
            } else {
                ppmButtons.push({
                    'ico': '', 'text': this.translate('graph_unlock_frequency'), 'func': () => {
                        this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled = true;
                        this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled = false;
                        this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = 'move';
                        this.fanRecalced.lines.TotalPressure.startPoint.svg.style.cursor = 'move';
                        this.fanRecalced.lines.TotalPressure.endPoint.svg.style.cursor = 'move';

                        this.fanRecalced.lines.StaticPressure.changingFerequencyEnabled = true;
                        this.fanRecalced.lines.StaticPressure.changingTemperatureEnabled = false;
                        this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = 'move';
                        this.fanRecalced.lines.StaticPressure.startPoint.svg.style.cursor = 'move';
                        this.fanRecalced.lines.StaticPressure.endPoint.svg.style.cursor = 'move';
                    }
                });
            }
            // NVS-92
            if (this.store.state.userRole === 'admin') {
                if (this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled) {
                    ppmButtons.push({
                        'ico': '', 'text': this.translate('graph_block_temperature'), 'func': () => {
                            this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled = false;
                            this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = '';

                            this.fanRecalced.lines.StaticPressure.changingTemperatureEnabled = false;
                            this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = '';
                        }
                    });
                } else {
                    ppmButtons.push({
                        'ico': '', 'text': this.translate('graph_unlock_temperature'), 'func': () => {
                            this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled = true;
                            this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled = false;
                            this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = 'move';
                            this.fanRecalced.lines.TotalPressure.startPoint.svg.style.cursor = 'move';
                            this.fanRecalced.lines.TotalPressure.endPoint.svg.style.cursor = 'move';

                            this.fanRecalced.lines.StaticPressure.changingTemperatureEnabled = true;
                            this.fanRecalced.lines.StaticPressure.changingFerequencyEnabled = false;
                            this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = 'move';
                            this.fanRecalced.lines.StaticPressure.startPoint.svg.style.cursor = 'move';
                            this.fanRecalced.lines.StaticPressure.endPoint.svg.style.cursor = 'move';
                        }
                    });
                }
            }
        }

        if (this.requestedPointEnabled) {
            ppmButtons.push({
                'ico': '', 'text': this.translate('graph_block_desired_point'), 'func': () => {
                    this.requestedPointEnabled = false;

                    if (this.requestedPoint)
                        this.requestedPoint.svg.querySelector("circle").style.cursor = '';
                }
            });
        } else {
            ppmButtons.push({
                'ico': '', 'text': this.translate('graph_unlock_desired_point'), 'func': () => {
                    this.requestedPointEnabled = true;
                    if (this.requestedPoint)
                        this.requestedPoint.svg.querySelector("circle").style.cursor = 'move';
                }
            });
        }


        Ppm.show(e, ppmButtons);
        e.preventDefault();

        return false;
    }
}

export {fanSummary};